export default "__VITE_ASSET__DyJ_68F___"